module.exports = __webpack_public_path__ + "static/media/logoApp.7c9ae8e1.svg";